import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { productAdd } from "../../Redux/Actions/ProductActions";
import { PRODUCT_CLEAR } from "../../Redux/Constants/ProductConstants";
import Loading from "../LoadingError/Loading";
import Toast from "../LoadingError/Toast";
import MainPanel from "../main-panel/MainPanel";
import Message from "../LoadingError/Error";
import { listCategories } from "../../Redux/Actions/CategoryActions";
import { BASE_URL, PICTURE_URL } from "../../api/BaseConfig";
import axios from "axios";
import FormData from 'form-data'
import { Box, Button, Checkbox, FormControl, FormLabel, Heading, Image, Input, Select, Spinner } from "@chakra-ui/react";

const ToastObjects = {
  pauseOnFocusLoss: false,
  draggable: false,
  pauseOnHover: false,
  autoClose: 2000,
};

const AddProductMain = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const languageList = [
    { id: 1, langKey: "AZ" },
    { id: 2, langKey: "GB" },
    { id: 3, langKey: "RU" },
  ];

  const [price, setPrice] = useState();
  const [discount, setDiscount] = useState();
  const [categoryID, setCategoryID] = useState(null);
  const [photoUrl, setPhotoUrl] = useState("");
  const [isFeatured, setIsFeatured] = useState(false);
  const [language, setLanguage] = useState([]);
  const [imageTitle, setImageTitle] = useState("");
  const [imageAlt, setImageAlt] = useState("");

  const onHandleLangChange = useCallback((dataInfo) => {
    let languageList = {
      name: dataInfo.name,
      description: dataInfo.description,
      seoTitle: dataInfo.seoTitle,
      seoDescription: dataInfo.seoDescription,
      languageKey: dataInfo.lang,
    };
    setLanguage((ln) => [
      ...ln.filter(
        (l) => l.languageKey !== dataInfo.lang && l.languageKey !== ""
      ),
      languageList,
    ]);
  }, []);
  const productCreate = useSelector((state) => state.productAdd);
  const { loading, error, product } = productCreate;

  const categoryList = useSelector((state) => state.categoryList);
  const { categories } = categoryList;

  useEffect(() => {
    if (product) {
      toast.success("Product successfully added!", ToastObjects);
      dispatch({ type: PRODUCT_CLEAR });
      setDiscount(0);
      setIsFeatured(false);
      setImageTitle("");
      setImageAlt("");
      setPrice(0);
      setPhotoUrl("");
    }
  }, [product, dispatch]);

  useEffect(() => {
    dispatch(listCategories("AZ"));
  }, [dispatch]);

  const handlePicture = (e) => {
    let data = new FormData();
    data.append("file", e, e.name);

    axios
      .post(BASE_URL + "/file", data, {
        headers: {
          accept: "application/json",
          "Accept-Language": "en-US,en;q=0.8",
          "Content-Type": `multipart/form-data; boundary=${data._boundary}`,
        },
      })
      .then((x) => {
        setPhotoUrl(x.data);
      })
      .catch((err) => alert(err));
  };

  const submitHandler = (e) => {
    e.preventDefault();
    try {
      dispatch(
        productAdd({
          price,
          discount,
          categoryId: Number(categoryID),
          photoUrl,
          imageTitle,
          imageAlt,
          ProductRecords: language,
        })
      );
      toast.success("Product successfully added!", ToastObjects);
      setTimeout(() => {
        history.push("/products");
      }, 2000);
    } catch {
      toast.error("Failed to add Product", ToastObjects);
    }
  };

  const handleChange = (event) => {
    setCategoryID(event.target.value);
  };

  return (
    <>
      <Toast />
      <Box maxW="1200px" mx="auto" p={4}>
        <form onSubmit={submitHandler}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
            <Button
              as={Link}
              to="/products"
              colorScheme="red"
              variant="solid"
              _hover={{
                backgroundColor: "red.600",
                color: "white",
              }}
            >
              Go to products
            </Button>
            <Heading as="h2" size="lg" color="teal.600">
              Add Product
            </Heading>
            <Button type="submit" colorScheme="teal">
              Publish Now
            </Button>
          </Box>

          <Box bg="white" p={6} shadow="md" borderRadius="lg">
            {error && <Message variant="alert-danger">{error.message || error}</Message>}
            {loading && <Spinner color="blue.500" size="lg" />}
            <Box mb={4}>
              <MainPanel
                mainLang={languageList}
                changeLang={onHandleLangChange}
                languageInfo={language}
              />
            </Box>

            <FormControl mb={4}>
              <FormLabel htmlFor="product_categories">Categories</FormLabel>
              <Select
                id="product_categories"
                value={Number(categoryID)}
                onChange={handleChange}
                required
                placeholder="--Select Categories--"
              >
                {categories?.map((category) => (
                  <option value={Number(category.id)} key={Number(category.id)}>
                    {category.categoryRecords[0]?.name}
                  </option>
                ))}
              </Select>
            </FormControl>

            <FormControl mb={4}>
              <FormLabel htmlFor="product_price">Price</FormLabel>
              <Input
                type="number"
                placeholder="Price"
                id="product_price"
                onChange={(e) => setPrice(Number(e.target.value))}
              />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel htmlFor="product_discount">Discount</FormLabel>
              <Input
                type="number"
                placeholder="Discount"
                id="product_discount"
                onChange={(e) => setDiscount(Number(e.target.value))}
              />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel htmlFor="product_featured">Is Featured?</FormLabel>
              <Checkbox
                id="product_featured"
                isChecked={isFeatured}
                onChange={(e) => setIsFeatured(e.target.checked)}
              >
                Featured Product
              </Checkbox>
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>Images</FormLabel>
              <Input
                type="file"
                onChange={(e) => handlePicture(e.target.files[0])}
              />
              {photoUrl && (
                <Box
                  mt={3}
                  width="300px"
                  height="250px"
                  overflow="hidden"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  bgcolor="lightgray"
                >
                  <Image
                    src={PICTURE_URL + photoUrl}
                    alt="Uploaded Image"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                    }}
                  />
                </Box>
              )}

            </FormControl>
            <FormControl mb={4}>
              <FormLabel htmlFor="image_title">Image Title</FormLabel>
              <Input
                type="text"
                id="image_title"
                value={imageTitle}
                onChange={(e) => setImageTitle(e.target.value)}
                placeholder="Enter image title"
              />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel htmlFor="image_alt">Image Alt Text</FormLabel>
              <Input
                type="text"
                id="image_alt"
                value={imageAlt}
                onChange={(e) => setImageAlt(e.target.value)}
                placeholder="Enter image alt text"
              />
            </FormControl>
          </Box>
        </form>
      </Box>
    </>
  );
};

export default AddProductMain;
